@if (loggedIn) {
  <div class="po-wrapper app-shell" [class.app-shell--development]="isDevelopment">
    @if (isDevelopment) {
      <div class="app-environment-banner" role="status">
        <span class="app-environment-banner__label">DEV</span>
        <span>Ambiente de desenvolvimento</span>
      </div>
    }
    <po-toolbar
      [p-title]="toolbarTitle"
      [p-actions-icon]="cartToolbarIcon"
      [p-actions]="toolbarActions"
      [p-profile]="profile"
      [p-profile-actions]="profileActions"
      [p-show-notification]="false"
    ></po-toolbar>
    <ng-template #cartToolbarIcon>
      <span class="toolbar-cart-icon" aria-label="Carrinho">
        <po-icon p-icon="ICON_CART"></po-icon>
        @if (quantidadeCarrinho > 0) {
          <span class="toolbar-cart-icon__badge">
            {{ quantidadeCarrinho > 9 ? '9+' : quantidadeCarrinho }}
          </span>
        }
      </span>
    </ng-template>
    <po-menu
      [p-menus]="menus"
      [p-logo]="logo"
      [p-filter]="true"
      [p-collapsed]="menuCollapsed"
      [p-automatic-toggle]="false"
      (p-toggle)="onMenuToggle($event)"
    ></po-menu>
    <nav class="mobile-bottom-nav" aria-label="Menu principal">
      @for (item of bottomNavigationItems; track item.id) {
        <a
          class="mobile-bottom-nav__item"
          [routerLink]="item.link"
          [class.mobile-bottom-nav__item--active]="isBottomNavActive(item.link)"
          [attr.aria-current]="isBottomNavActive(item.link) ? 'page' : null"
        >
          <span class="mobile-bottom-nav__icon" aria-hidden="true">
            <po-icon [p-icon]="item.icon"></po-icon>
            @if (item.id === 'compras-carrinho' && quantidadeCarrinho > 0) {
              <span class="mobile-bottom-nav__badge">
                {{ quantidadeCarrinho > 9 ? '9+' : quantidadeCarrinho }}
              </span>
            }
          </span>
          <span class="mobile-bottom-nav__label">{{ item.label }}</span>
        </a>
      }
    </nav>
    <router-outlet></router-outlet>
    <footer class="app-footer" aria-label="Informações da aplicação">
      <div class="app-footer__content">
        <span>Flink</span>
        <po-tag
          [p-value]="'v' + version"
          [p-type]="versionType"
        ></po-tag>
        <po-tag
          [p-value]="environmentLabel"
          [p-type]="environmentType"
        ></po-tag>
      </div>
    </footer>
  </div>
}

@if (!loggedIn) {
  <po-page-default>
    <router-outlet></router-outlet>
  </po-page-default>
}
